// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { KeyCode } from '@shared/commons/KeyEventProcessor';
import { TerceraLabel } from '../elements/TerceraLabel';
import { TerceraWindowBase } from './TerceraWindowBase';
import { TerceraLookupEvents } from '../elements/Lookup/TerceraLookup';
import { TerceraInstrumentLookup } from '../elements/Lookup/TerceraInstrumentLookup';
export class TerceraQuickInstrumentLookupScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return 'TerceraQuickInstrumentLookupScreen';
    }
    static Show(posX, posY, event, callBackForInstrumentSelection, functionForOpenQuickTree, parent) {
        const terceraquickinstrumentlookupscreen = new TerceraQuickInstrumentLookupScreen();
        terceraquickinstrumentlookupscreen.setLocation(posX, posY);
        MainWindowManager.AddControl(terceraquickinstrumentlookupscreen);
        terceraquickinstrumentlookupscreen.callBackForInstrumentSelection = callBackForInstrumentSelection;
        terceraquickinstrumentlookupscreen.functionForOpenQuickTree = functionForOpenQuickTree;
        terceraquickinstrumentlookupscreen.parentFocus = parent;
        const lookup = new TerceraInstrumentLookup();
        lookup.oninit();
        lookup.setLocation(10, 30);
        void lookup.set({ width: 255, isPosAbsolute: true });
        lookup.off('lookupBtnClick');
        lookup.on('lookupBtnClick', function () {
            if (this.functionForOpenQuickTree) {
                this.functionForOpenQuickTree();
            }
            this.close();
        }.bind(terceraquickinstrumentlookupscreen));
        lookup.on(TerceraLookupEvents.SelectedItemChanged, function (sender, newInstrument) {
            if (this.callBackForInstrumentSelection) {
                this.callBackForInstrumentSelection([newInstrument]);
            }
            this.close();
        }.bind(terceraquickinstrumentlookupscreen));
        lookup.on('complete', function (event) {
            this.set({ selectedItem: null });
            this.selectedItem = null;
            this.textBox.set({ text: '' });
            this.selectedItemIndex = -1;
            setTimeout(function () {
                this.textBox.set({ text: event.original.key, skipfocus: true });
                this.textBox.setFocus();
            }.bind(this), 10);
        }.bind(lookup, event));
        // lookup.moveToItem = function () { };
        terceraquickinstrumentlookupscreen.addControl(lookup);
        lookup.CanMoveToNextIfHaveError = false;
        const label = new TerceraLabel();
        label.setLocation(10, 10);
        void label.set({ text: lookup.getButtonTooltip(), isPosAbsolute: true });
        terceraquickinstrumentlookupscreen.addControl(label);
        return terceraquickinstrumentlookupscreen;
    }
    lostFocus() {
        super.lostFocus();
        this.close();
    }
    onKeyDown(event) {
        if (event.original.keyCode === KeyCode.ESC) {
            this.close();
            return true;
        }
    }
    close() {
        if (this.parentFocus) {
            const func = function () {
                this.setFocus();
                this.find('div').focus();
            }.bind(this.parentFocus);
            delete this.parentFocus;
            func();
        }
        super.close();
    }
}
// такое же как и в конструкторе
TerceraQuickInstrumentLookupScreen.WIDTH = 270;
TerceraQuickInstrumentLookupScreen.HEIGHT = 70;
TerceraWindowBase.extendWith(TerceraQuickInstrumentLookupScreen, {
    data: function () {
        return {
            height: TerceraQuickInstrumentLookupScreen.HEIGHT,
            width: TerceraQuickInstrumentLookupScreen.WIDTH,
            header: '',
            resizable: false,
            showFooter: false,
            movable: false,
            showHeader: false
        };
    }
});
